import './src/styles/global.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { startRouteProgress, finishRouteProgress } from "./src/utils/route-progress";

// Gatsby renders a new route only once its data and JavaScript have downloaded.
// On a slow connection the URL changes at once and the previous page stays on
// screen for seconds, which reads as a dead tab. These two hooks say otherwise:
// Gatsby calls the first when a navigation passes its delay threshold, and the
// second when the page actually renders.
export const onRouteUpdateDelayed = () => startRouteProgress();
export const onRouteUpdate = () => finishRouteProgress();
